"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { InlineFormConstants } from "Constants/Forms/InlineFormConstants";
import { ApplicationConstants } from "Constants/ApplicationConstants";
import { loadFilterFields, loadFormFields, loadFormGroups, loadFormMetadata, loadSubForms, loadFormDecorationElements, loadFormFilterFieldEvents } from "D5Utils/common_requests";
import { Fields, System } from "Constants/objects";
import { DetailStore, MasterDetail } from "Components/TableCore/master_detail";
import Columns from "Stores/Table/core/table/Columns";
import { createTableID, getAddFilter, getLSTableCols, setAddSSFilter, setSSTableCols, setShowRowSSFilter, getShowRowFilter, getTitlePosition } from "D5Utils/functions";
var defStore = {
  formID: null,
  type: null,
  tableTitle: '',
  showTable: false,
  subForms: null,
  groups: null,
  items: null,
  formInstance: null,
  filterFields: null,
  formFields: null,
  ready: false
};
var _System$LAYOUT_TYPE = System.LAYOUT_TYPE,
    SUBFORM = _System$LAYOUT_TYPE.SUBFORM,
    FILTER = _System$LAYOUT_TYPE.FILTER,
    DECORATION = _System$LAYOUT_TYPE.DECORATION;
var _store = {};

var setDefStore = function setDefStore() {
  _store = _objectSpread({}, defStore);
};

setDefStore();
var CHANGE_EVENT = 'change';

var InlineFormStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(InlineFormStoreClass, _StoreClass);

  function InlineFormStoreClass() {
    _classCallCheck(this, InlineFormStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(InlineFormStoreClass).apply(this, arguments));
  }

  _createClass(InlineFormStoreClass, [{
    key: "getList",
    value: function getList() {
      return _objectSpread({}, _store);
    }
  }, {
    key: "destructor",
    value: function destructor() {
      setDefStore();
    }
  }, {
    key: "createGroupProp",
    value: function createGroupProp(item) {
      var _System$ORIENTATION = System.ORIENTATION,
          NUM = _System$ORIENTATION.NUM,
          STR = _System$ORIENTATION.STR;
      var group = {
        id: item[Fields.ID],
        parentID: item[Fields.ParentGroupID],
        order: item[Fields.Order],
        isGroup: true,
        isVisible: item[Fields.IsVisible],
        orientation: item[Fields.Orientation] === NUM.ROW ? STR.ROW : STR.COLUMN,
        groupType: item[Fields.GroupType],
        isCollapsed: item[Fields.IsCollapsed],
        title: item[Fields.Title],
        isShowTitle: item[Fields.IsShowTitle]
      };

      if (group.title && group.isShowTitle) {
        group['caption'] = group.title;
      } else {
        group['cssClass'] = 'form-no-padding';
        group[Fields.Title] = group.title;
      }

      return group;
    }
  }, {
    key: "initNewForm",
    value: function initNewForm(_ref) {
      var _this = this;

      var formID = _ref.formID;
      var _System$GROUP_TYPE = System.GROUP_TYPE,
          PANEL = _System$GROUP_TYPE.PANEL,
          TAB_PANEL = _System$GROUP_TYPE.TAB_PANEL,
          TAB = _System$GROUP_TYPE.TAB,
          ACCORDION = _System$GROUP_TYPE.ACCORDION;
      Promise.all([loadFormGroups({
        formID: formID,
        groupType: [PANEL, TAB_PANEL, TAB, ACCORDION]
      }), loadSubForms(formID), loadFormMetadata(formID), loadFormDecorationElements(formID)]).then(function (data) {
        var loadedGroups = data[0].filter(function (f) {
          return f.IsVisible;
        });
        var subForms = data[1]; //table

        var formMeta = data[2];
        var decorationElements = data[3];
        var subFormIDs = subForms.map(function (item) {
          return item[Fields.DetailFormID];
        });
        _store.formID = formID;
        var ids = [formID].concat(_toConsumableArray(subFormIDs));
        Promise.all([loadFormFields(ids), loadFilterFields({
          id: ids,
          filter: _defineProperty({}, Fields.FormID, {
            '=': ids
          })
        })]).then(function (data) {
          var formFields = data[0];

          var formFilters = _.groupBy(data[1], Fields.FormID); //filters


          var fieldsByFormID = _.groupBy(formFields, Fields.FormID);

          if (formFilters[formID]) {
            loadFormFilterFieldEvents(formFilters[formID].map(function (f) {
              return f.ID;
            })).then(function (filterEvents) {
              _this.processData(subForms, formFilters, fieldsByFormID, formMeta, formID, loadedGroups, decorationElements, filterEvents);
            });
          } else {
            _this.processData(subForms, formFilters, fieldsByFormID, formMeta, formID, loadedGroups, decorationElements);
          }
        });
      });
    }
  }, {
    key: "processData",
    value: function processData(subForms, formFilters, fieldsByFormID, formMeta, formID, loadedGroups, decorationElements, filterEvents) {
      var _this2 = this;

      subForms = this.initMasterDetails(subForms, {
        formFilters: formFilters,
        fieldsByFormID: fieldsByFormID,
        formMeta: formMeta,
        formID: formID
      });

      var groups = _.sortBy(loadedGroups, Fields.Order).map(function (item) {
        return _this2.createGroupProp(item);
      });

      var filterItems = this.getFilterItems(formFilters[formID], fieldsByFormID[formID], filterEvents);
      var subFormItems = this.getSubFormItems(subForms); // items for table

      var decorationItems = this.getDecorItems(decorationElements);
      _store.groups = groups;
      _store.items = [].concat(_toConsumableArray(subFormItems), _toConsumableArray(filterItems), _toConsumableArray(decorationItems));
      _store.showTable = true;
      _store.ready = true;
      subForms.forEach(function (sub) {
        if (sub[Fields.DetailFormID_Type] === System.FORM_TYPE.LIST || sub[Fields.DetailFormID_Type] === System.FORM_TYPE.TREE) {
          var lsName = createTableID(sub.DetailFormID, sub.FormID);
          setSSTableCols(lsName, getLSTableCols(lsName));
          setAddSSFilter(lsName, getAddFilter(lsName));
          setShowRowSSFilter(lsName, getShowRowFilter(lsName));
        }
      });
      this.emit(CHANGE_EVENT);
    }
  }, {
    key: "updateDetailProps",
    value: function updateDetailProps(subForms, _ref2) {
      var _this3 = this,
          _objectSpread2;

      var fieldsByFormID = _ref2.fieldsByFormID,
          formMeta = _ref2.formMeta,
          formFilters = _ref2.formFilters,
          formID = _ref2.formID;
      var parent;
      var _System$RELATION_TYPE = System.RELATION_TYPE,
          MASTER = _System$RELATION_TYPE.MASTER,
          DETAIL = _System$RELATION_TYPE.DETAIL;
      subForms = subForms.map(function (item) {
        var tableFields = _this3.fieldsFromTable(fieldsByFormID[item[Fields.DetailFormID]]);

        if (item[Fields.RelationType] === MASTER) parent = _objectSpread({}, item);
        return _objectSpread({}, item, {
          viewSource: tableFields,
          formFilters: formFilters[item[Fields.DetailFormID]],
          requestColumns: _this3.requestTableColumns(tableFields, item[Fields.FormID_ObjectID_KeyObjectFieldID_Name])
        });
      });
      var mainFormFields = this.fieldsFromTable(fieldsByFormID[formID]); //если subForm - MASTER, значит mainForm нужно сделать деталью

      var formObj = {};

      if (parent) {
        formObj[Fields.FormID] = parent[Fields.DetailFormID];
        formObj[Fields.DetailObjectFieldID_Name] = parent[Fields.DetailObjectFieldID_Name];
        formObj[Fields.MasterObjectFieldID_Name] = parent[Fields.MasterObjectFieldID_Name];
        formObj[Fields.FormID_ObjectID_Name] = parent[Fields.FormID_ObjectID_Name];
        formObj[Fields.FormID_ObjectID_KeyObjectFieldID_Name] = parent[Fields.FormID_ObjectID_KeyObjectFieldID_Name]; //всем деталям прописать ссылку на мастера

        subForms = subForms.map(function (item) {
          if (item[Fields.RelationType] === DETAIL) item[Fields.FormID] = parent[Fields.DetailFormID];
          return item;
        });
      }

      subForms.unshift(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, Fields.DetailFormID, formMeta[Fields.ID]), _defineProperty(_objectSpread2, Fields.DetailFormID_Type, formMeta[Fields.Type]), _defineProperty(_objectSpread2, Fields.FormID, null), _defineProperty(_objectSpread2, Fields.GroupID, formMeta[Fields.MainGroupID]), _defineProperty(_objectSpread2, Fields.ID, formMeta[Fields.ID]), _defineProperty(_objectSpread2, Fields.Name, formMeta[Fields.Name]), _defineProperty(_objectSpread2, Fields.Order, -1), _defineProperty(_objectSpread2, Fields.RelationType, parent ? DETAIL : MASTER), _objectSpread2), formObj, {
        viewSource: mainFormFields,
        formFilters: formFilters[formMeta[Fields.ID]],
        requestColumns: this.requestTableColumns(mainFormFields, formMeta[Fields.ObjectID_KeyObjectFieldID_Name])
      }));
      return subForms;
    }
  }, {
    key: "getFilterItems",
    value: function getFilterItems() {
      var filterFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var viewSource = arguments.length > 1 ? arguments[1] : undefined;
      var filterEvents = arguments.length > 2 ? arguments[2] : undefined;
      var mainFormFilters = filterFields.filter(function (f) {
        return f[Fields.IsShowInMainForm];
      });
      return mainFormFilters.map(function (filter) {
        return {
          id: filter.ID,
          itemType: FILTER,
          parentID: filter[Fields.GroupID],
          order: filter.Order,
          isVisible: Boolean(filter[Fields.IsVisible]),
          isRequired: Boolean(filter[Fields.IsRequired]),
          label: {
            text: window.D5.isDebugMode() ? "".concat(filter[Fields.Title], " {").concat(filter[Fields.Name], "}") : filter[Fields.Title],
            visible: Boolean(filter[Fields.IsShowTitle]),
            location: getTitlePosition(filter),
            showColon: getTitlePosition(filter) !== 'right'
          },
          options: _objectSpread({}, filter, {
            viewSource: viewSource,
            filterEvents: filterEvents,
            formFilters: mainFormFilters
          })
        };
      });
    }
  }, {
    key: "getDecorItems",
    value: function getDecorItems(items) {
      return items.map(function (item) {
        return {
          id: item.ID,
          itemType: DECORATION,
          isVisible: Boolean(item[Fields.IsVisible]),
          parentID: item[Fields.GroupID],
          order: item.Order,
          options: item
        };
      });
    }
    /**
     * @param {array} fields
     */

  }, {
    key: "fieldsFromTable",
    value: function fieldsFromTable() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var systemFields = [];
      var lookupFields = fields.map(function (field) {
        if (field[Fields.ObjectFieldID_LinkedObjectID]) {
          var _objectSpread3;

          if (!field[Fields.DisplayField]) {
            field[Fields.DisplayField] = field[Fields.ObjectFieldID_DisplayObjectFieldID_Name];
          } //KeyFilterField - ключевое поле объекта, например CountryID


          field[Fields.KeyFilterField] = field[Fields.ObjectFieldID_Name]; //ObjectFieldID_Name - полное название с точкой, например CountryID.Name
          // field[Fields.DisplayField] проверяется повторно для исключения полей вида ParentID.null
          // https://teamtrack.macc.com.ua/view.php?id=60019

          if (field[Fields.DisplayField]) {
            field[Fields.ObjectFieldID_Name] += '.' + field[Fields.DisplayField];
          }

          field[Fields.ObjectFieldID_FieldType] = field[Fields.ObjectFieldID_DisplayObjectFieldID_FieldType];
          systemFields.push(_objectSpread({}, field, (_objectSpread3 = {}, _defineProperty(_objectSpread3, Fields.Name, System.SYSTEM_PREFIX + field[Fields.Name]), _defineProperty(_objectSpread3, Fields.IsVisible, 0), _objectSpread3)));
        }

        return field;
      });
      return [].concat(_toConsumableArray(lookupFields), systemFields);
    }
  }, {
    key: "requestTableColumns",
    value: function requestTableColumns(fields, keyField) {
      // Определение колонок для отправки на сервер
      // Добавлена проверка на дубликаты
      var requestColumns = [];
      fields.forEach(function (item) {
        if (Columns.isSystemField(item)) return;

        if (item[Fields.KeyFilterField] && !requestColumns.includes(item[Fields.KeyFilterField])) {
          requestColumns.push(item[Fields.KeyFilterField]);
        }

        if (item[Fields.ObjectFieldID_Name] && !requestColumns.includes(item[Fields.ObjectFieldID_Name])) {
          requestColumns.push(item[Fields.ObjectFieldID_Name]);
        }
      });
      if (!requestColumns.includes(keyField)) requestColumns.push(keyField);
      return requestColumns;
    }
  }, {
    key: "getSubFormItems",
    value: function getSubFormItems(subForms) {
      var sorted = _.sortBy(subForms, Fields.Order);

      return sorted.map(function (item) {
        var filter = null;

        if (item[Fields.FormID] != null) {
          filter = _defineProperty({}, item[Fields.DetailObjectFieldID_Name], undefined);
        }

        return {
          id: item[Fields.ID],
          itemType: SUBFORM,
          parentID: item[Fields.GroupID],
          order: item[Fields.Order],
          options: {
            id: "detail-form-".concat(item[Fields.DetailFormID]),
            formID: item[Fields.DetailFormID],
            formType: item[Fields.DetailFormID_Type],
            parentFormID: item[Fields.FormID],
            parentGroupID: item[Fields.GroupID],
            filtersData: filter,
            requestColumns: item.requestColumns,
            viewSource: item.viewSource,
            formFilters: item.formFilters,
            isFocus: null,
            isVisible: 1,
            relationType: item[Fields.RelationType]
          }
        };
      });
    }
  }, {
    key: "initMasterDetails",
    value: function initMasterDetails(subForms, _ref3) {
      var formFilters = _ref3.formFilters,
          fieldsByFormID = _ref3.fieldsByFormID,
          formMeta = _ref3.formMeta,
          formID = _ref3.formID;
      subForms = this.updateDetailProps(subForms, {
        formFilters: formFilters,
        fieldsByFormID: fieldsByFormID,
        formMeta: formMeta,
        formID: formID
      });
      subForms.forEach(function (item) {
        MasterDetail.setTable(item[Fields.DetailFormID], new DetailStore({
          tableID: item[Fields.DetailFormID],
          masterID: item[Fields.FormID],
          detailField: item[Fields.DetailObjectFieldID_Name],
          masterField: item[Fields.MasterObjectFieldID_Name],
          masterObjectName: item[Fields.FormID_ObjectID_Name],
          masterKeyField: item[Fields.FormID_ObjectID_KeyObjectFieldID_Name]
        }));
      });
      return subForms;
    }
  }]);

  return InlineFormStoreClass;
}(StoreClass);

var InlineFormStore = new InlineFormStoreClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case InlineFormConstants.INLINE_FORM_SET_TITLE:
      _store.tableTitle = action.title;
      InlineFormStore.emit(CHANGE_EVENT);
      break;

    case InlineFormConstants.INLINE_FORM_SHOW_TABLE:
      _store.showTable = action.show;
      InlineFormStore.emit(CHANGE_EVENT);
      break;

    case InlineFormConstants.INLINE_FORM_SET_INSTANCE:
      _store.formInstance = action.formInstance;
      break;

    case ApplicationConstants.DO_LOGOUT:
      {
        InlineFormStore.destructor();
        break;
      }

    default:
      return true;
  }
});
export default InlineFormStore;